import React from 'react';
import { connect } from 'react-redux';
//Actions
import { logGet } from '../../actions/log';
// Material UI
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

function SelectLog({ clans, clan, logGet, setClan, setView, view }) {
  const classes = useStyles();
  const handleClanSelect = (e) => {
    logGet(view, e.target.value);
    setClan(e.target.value);
  };
  return (
    <div>
      <FormControl className={classes.formControl}>
        <InputLabel>Ver Registros</InputLabel>
        <Select value={view} onChange={(e) => setView(e.target.value)}>
          <MenuItem value={'app'}>App</MenuItem>
          <MenuItem value={'guard'}>Guardia</MenuItem>
          <MenuItem value={'intercom'}>Intercom</MenuItem>
          <MenuItem value={'phonebot'}>Llamada</MenuItem>
          <MenuItem value={'pass'}>Pases</MenuItem>
          <MenuItem value={'tag'}>Tarjetas</MenuItem>
        </Select>
      </FormControl>
      <FormControl className={classes.formControl}>
        <InputLabel>Domicilio</InputLabel>
        <Select value={clan} onChange={handleClanSelect}>
          <MenuItem value={0}>Todos</MenuItem>
          {clans.map(({ address, id }, i) => (
            <MenuItem value={id} key={i}>
              {address}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

const mapStateToProps = (state) => ({
  clans: state.clans.data,
});

const mapDispatchToProps = (dispatch) => ({
  logGet: (method, clan) => dispatch(logGet(method, clan)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectLog);
